import script from "./Toggle.vue?vue&type=script&setup=true&lang=js"
export * from "./Toggle.vue?vue&type=script&setup=true&lang=js"

import "./Toggle.vue?vue&type=style&index=0&id=55c1ffb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55c1ffb1"]])

export default __exports__